import { render, staticRenderFns } from "./addForum.vue?vue&type=template&id=674ecca3"
import script from "./addForum.vue?vue&type=script&lang=js"
export * from "./addForum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports